import { render, staticRenderFns } from "./gestionCodigosLista.vue?vue&type=template&id=a98f7784&scoped=true"
import script from "./gestionCodigosLista.vue?vue&type=script&lang=js"
export * from "./gestionCodigosLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98f7784",
  null
  
)

export default component.exports